import type { IconNode } from '../types';

/**
 * @name midi-port
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMThoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNSAyLjQ1OFY1YTEgMSAwIDAxLTEgMWgtNGExIDEgMCAwMS0xLTFWMi40NTgiIC8+CiAgPHBhdGggZD0iTTE2IDE2aC4wMSIgLz4KICA8cGF0aCBkPSJNMTggMTJoLjAxIiAvPgogIDxwYXRoIGQ9Ik02IDEyaC4wMSIgLz4KICA8cGF0aCBkPSJNOCAxNmguMDEiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/midi-port
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MidiPort: IconNode = [
  ['path', { d: 'M12 18h.01' }],
  ['path', { d: 'M15 2.458V5a1 1 0 01-1 1h-4a1 1 0 01-1-1V2.458' }],
  ['path', { d: 'M16 16h.01' }],
  ['path', { d: 'M18 12h.01' }],
  ['path', { d: 'M6 12h.01' }],
  ['path', { d: 'M8 16h.01' }],
  ['circle', { cx: '12', cy: '12', r: '10' }],
];

export default MidiPort;
